import state from '@/store/base/states'
import getters from '@/store/base/getters'
import mutations from '@/store/base/mutations'
import actions from '@/store/base/actions'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  strict: (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'production-dev' && process.env.NODE_ENV !== 'production-staging')
}
